<template>
  <div class="mt-2">
    <div class="final-price d-flex justify-content-end lead">
      <p class="mb-0">
        <span>
          <span>Total: </span>
          <vue-numeric
            v-model="total"
            currency="€"
            currency-symbol-position="suffix"
            :precision="2"
            read-only-class="read-only-class"
            readOnly />
        </span>
      </p>
    </div>
    <div class="final-price d-flex justify-content-end lead">
      <p class="mb-0">
        <span>
          <span>IVA <small>(21%)</small>: </span>
          <vue-numeric
            :value="iva"
            currency="€"
            currency-symbol-position="suffix"
            :precision="2"
            read-only-class="read-only-class"
            readOnly />
        </span>
      </p>
    </div>
    <div class="final-price d-flex justify-content-end lead">
      <p class="mt-0 border-top">
        <span>
          <span>Total <small>(+ IVA)</small>: </span>
          <vue-numeric
            :value="suma"
            currency="€"
            currency-symbol-position="suffix"
            :precision="2"
            read-only-class="read-only-class"
            readOnly />
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'

export default {
  name: 'FinalPrice',
  components: {
    VueNumeric
  },
  props: {
    total: {
      type: Number || String,
      required: true
    }
  },
  computed: {
    iva () {
      return this.total * 0.21 || 0
    },
    suma () {
      return this.total + this.iva || 0
    }
  }
}
</script>

<style lang="stylus" scoped>
.final-price
  .read-only-class
    font-family monospace
    font-size: 24px
    margin-left 10px
</style>
